import httpService from './httpService';

export interface IFund {
  address1: any;
  address2: any;
  city: any;
  discriminator: any;
  email: any;
  id: number;
  legalName: any;
  name: string;
  phoneNumber: any;
  postalAddress: any;
  postalCode: any;
  state: any;
}

export const getFunds = (): Promise<IFund[]> => {
  let endpoint = httpService.getEndpointURL('/Funds');
  return httpService.get(endpoint).then((res) => res.data);
};
